import { authHeader, handleResponse } from '../helpers'

export const imageService = {
    getLibraryImages,
    createImage,
    deleteImage
};

function getLibraryImages() {
    const requestOptions = {
        method: "GET",
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_API_URL + '/images', requestOptions)
        .then(handleResponse)
        .then(response => {
            var images = response.images;
            return images;
        });
}

function createImage(imageData) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: imageData
    };
    return fetch(process.env.VUE_APP_API_URL + '/imagecreate', requestOptions)
    .then(handleResponse)
    .then(response => {
        var image = response;
        return image;
    });
}

function deleteImage(imageId) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };
    return fetch(process.env.VUE_APP_API_URL + '/image/' + imageId, requestOptions)
    .then(handleResponse)
    .then(response => {
        var image = response;
        return image;
    });
}